define('views/modules/calendar/nutrition/entry/nutrition-day-log',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/events/nutrition-events',
    // models & collections
    'collections/calendar/nutrition/entries',
    // views
    'src/views/responsive-view',
    'views/modules/calendar/nutrition/entry/food-entry-list',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    NutritionEvents,
    // models & collections
    CFoodEntries,
    // views
    VResponsive,
    VFoodEntryList
) {

    var VNutritionDayLog = VResponsive.extend({
        initialize: function(opt) {

            var collection = this.collection,
                entries = this.entriesCollection = {},
                view = this.view = {},
                instanciateFoodList = this._instanciateFoodList.bind(this);

            this.foodReceptor = instanciateFoodList('breakfast', 7, "calendar:Breakfast");
            instanciateFoodList('morning', 10, "calendar:Morning Snack");
            instanciateFoodList('lunch', 12, "calendar:Lunch");
            instanciateFoodList('afternoon', 15, "calendar:Afternoon Snack");
            instanciateFoodList('supper', 17, "calendar:Supper");
            instanciateFoodList('evening', 21, "calendar:Evening snack");

            this.resetCollections();

            this.listenTo(this.collection, {
                'reset': this.onEntriesReset,
                'entry:remove': this.onEntryRemove,
                'entry:suggest': this.onSuggestionClick,
            });
        },

        initListener: function() {
            this.stopListeningTo(NutritionEvents);
            this.listenTo(NutritionEvents, {
                'food:add': this.onFoodAdd,
                'markAllAsConsumed': this.markAllAs.bind(this, true),
                'markAllAsNotConsumed': this.markAllAs.bind(this, false)
            });
        },

        render: function() {
            this.initListener();
            this.$el.empty();
            this.renderViews();
            return this;
        },

        renderViews: function() {
            var container = document.createDocumentFragment(),
                view = this.view;
            _.each(this.view, function(value) {
                container.appendChild(value.render().el);
            }, this);

            this.$el.append(container);
            return this;
        },

        resetCollections: function() {
            var byHour = this.collection.groupBy('hour');
            _.each(this.entriesCollection, function(foodEntries) {
                foodEntries.reset(byHour[foodEntries.hour]);
            }, this);
        },

        _instanciateFoodList: function(key, hour, title) {
            var options = { hour: hour },
                newCollection = this.entriesCollection[key] = new CFoodEntries(null, options),
                view = this.view[key] = new VFoodEntryList({
                    hour: hour,
                    title: title,
                    collection: newCollection,
                    date: true,
                    model: this.model
                });
            this.listenTo(newCollection, {
                'entry:add': this.onEntryAdd,
                'entry:click:add': this.onAddClick
            });
            return view;
        },

        selectFoodReceptor: function(view) {
            var current = this.foodReceptor;
            if (current !== view) {
                if (current) current.toggleChosen(false);
                current = this.foodReceptor = view;
            }

            current.toggleChosen(true);
            this.trigger('add:food');
        },

        ////////////
        // events //
        ////////////
        onAddClick: function(view, hour) {
            this.selectFoodReceptor(view);
        },
        onSuggestionClick: function(model, entryItem) {
            this.selectFoodReceptor(entryItem);
        },
        onEntriesReset: function() {
            this.resetCollections();
        },
        onEntryRemove: function(model) {
            this.collection.remove(model);
        },
        onEntryAdd: function(model, position) {
            // Get the index of the first food for this hour (the hour of the model)
            var index = this.collection.findIndex({hour: model.get('hour')})
            var options = {};
            if (index >= 0 && position >= 0) options.at = index + position;
            this.collection.add(model, options);
            this.collection.trigger('entry:add', model);
        },
        onFoodAdd: function(foods) {
            this.foodReceptor.toggleChosen(false);
            _.each(foods, function(model) {
                this.foodReceptor.addEntry(model);
            }, this);
        },

        markAllAs: function(isEaten) {
            this.collection.each(function(model) {
                model.set({ isEaten: isEaten })
            });
        },

    });

    return VNutritionDayLog;
});

